// This is generated.  Alter it in blockGroups/formElements/types/ShortEncodedText.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      propertyName,
      minLength,
      maxLength,
      required,
      defaultValue,
    } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    const { isOptional: optional, schemaOptions } =
      moduleRegistration.resolveFieldFlags(required, context);

    // Helper to wrap a schema as optional if needed
    const maybeOptional = (schema) =>
      optional ? Type.Optional(schema) : schema;

    const pattern = '^[0-9a-fA-F]+$';

    // Build the string schema with hex pattern and constraints
    const stringOptions = {
      title: title,
      pattern: pattern,
      'x-id': id,
      'x-dataType': 'string',
      'x-propertyName': propertyName,
      ...schemaOptions,
    };

    // Add length constraints if provided
    if (minLength !== undefined && minLength !== null) {
      stringOptions.minLength = minLength;
    }
    if (maxLength !== undefined && maxLength !== null) {
      stringOptions.maxLength = maxLength;
    }
    if (defaultValue) {
      stringOptions.default = defaultValue;
    }

    const shortEncodedTextSchema = maybeOptional(Type.String(stringOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: shortEncodedTextSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'ShortEncodedText',
  module.exports,
);
